import React from 'react'
import SbEditable from 'storyblok-react'
import Button from 'src/components/Button'
import RichText from 'src/utils/RichText'


const FeatureCard = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div>
        <div
          className={`relative`}>
          <div
            className={`relative max-w-6xl mx-auto`}
          >
            <div
              className={`flex justify-center items-center ${blok.image_position?'md:flex-row flex-col':'md:flex-row-reverse flex-col-reverse'}  gap-5 mx-auto `}
            >
               <div className={`relative ${!blok.image_position && blok?.button_text?'-mt-24':'pt-0'}  p-[0.5px]`}>
                <img className='md:object-cover  object-center mx-auto lg:h-[560px] lg:w-[480px] md:w-[258px] md:h-[301px] w-[258px] h-[301px]'
                  src={blok.image.filename}
                  alt={blok.image.alt}
                  placeholderStyle={{ filter: `blur(1rem)` }}
                />
            
               </div>
              <div className={`max-w-2xl px-6    w-full text-left mx-auto`}>

                <p className={`prose font-display font-semibold  text-darkblue text-xl md:!text-2xl  pb-5 mx-auto not-prose`} >
                  <RichText>{blok.title}</RichText>
                </p>
                <p
                  className={`prose font-display font-normal text-base   !leading-[1.6rem]   mx-auto text-left not-prose
                   ${
                    blok.lightblue_background
                      ? 'text-darkblue-700'
                      : 'text-darkblue'
                  }`}
                >
                  <RichText>{blok.description}</RichText>
                  {/* {blok.description} */}
                </p>
                <Button
                  to={blok.button_target?.cached_url}
                  className='bg-[#002432] !rounded-full hover before:content-[attr(before)] mt-9 mb-28'
                  before={blok.button_text}
                >
                  {blok.button_text}
                </Button>
              </div>
             
            </div>
          </div>
        </div>
      
      </div>
    </SbEditable>
  )
}

export default FeatureCard
